import { render, staticRenderFns } from "./TaskViewModal.vue?vue&type=template&id=7047f870&scoped=true&"
import script from "./TaskViewModal.vue?vue&type=script&lang=js&"
export * from "./TaskViewModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewModal.vue?vue&type=style&index=0&id=7047f870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047f870",
  null
  
)

export default component.exports